module.exports = __webpack_public_path__ + "img/Masonry2.4e130009.jpeg";